import { Button } from '@iwoca/orion';
import { clsx } from 'clsx';

export const CancelButton = ({
  href,
  ...props
}: {
  href?: string;
} & React.HTMLAttributes<HTMLButtonElement>) => {
  if (!href) return null;

  const handleCancel = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    window.location.href = href;
  };

  return (
    <Button
      {...props}
      className={clsx('!text-error', props.className)}
      variant="tertiary"
      onClick={handleCancel}
    >
      Cancel order
    </Button>
  );
};
